<template>
    <el-main>
      <el-container class="main-item-container allocate-container">

        <!--乐器-->
        <div class="allocate">
          <span class="title">乐器类型</span>
          <div class="middle-operate">
            <div class="search-container1">
              <div>

                <input v-model="searchDrum" type="search" placeholder="请输入乐器名称" class="search-input">
                <img src="../../assets/search.png" alt="" class="searchImg" @click="searchData(0)">

                <!--<el-button size="mini" @click = 'getDataList'>搜索</el-button>-->
              </div>
            </div>

            <!--<el-input placeholder="请输入乐器名称" v-model="searchDrum" class="input-with-select"    size="small">-->
            <!--<el-button slot="append" icon="el-icon-search" class="search-btn"></el-button>-->
            <!--</el-input>-->
            <el-button size="mini" type="primary" plain @click="addRow(0)">添加</el-button>
            <el-button size="mini" type="danger" plain @click="deleteData(0)">删除</el-button>
          </div>
          <div class="drum-class">
            <!--乐器展示-->
            <el-table :data="drum_table" key="drum_table" style="width: 100%;margin:auto" ref="drumtable"
                      @select-all="handelSelectAll"
                      @select="drumRowClick"
                      class="drum-table" highlight-current-row>

              <el-table-column
                type="selection"
                width="50">
              </el-table-column>

              <el-table-column label="名称" width="" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" :disabled="!scope.row.disabled"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <!---->
                  <el-button v-if="scope.row.edit" type="success" plain  size="mini" class="operate-btn success-btn"
                             @click="saveRow(scope.row,0)">保存
                  </el-button>
                  <el-button v-if="scope.row.edit" class="cancel-btn operate-btn theme-btn" size="mini"
                             type="warning"  plain @click="cancelEdit(0)">取消
                  </el-button>
                  <el-button v-else type="primary" plain size="mini" class="operate-btn"
                             @click="editRow(scope.row,0)">编辑
                  </el-button>
                  <!--<el-button type="danger" size="mini" @click="handleConfig(scope.row)">删除</el-button>-->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!--曲册-->
        <div class="allocate">
          <span class="title">曲册</span>
          <div class="middle-operate">
            <div class="search-container1">
              <div>

                <input v-model="searchAlbum" type="search" placeholder="请输入曲册名称" class="search-input">
                <img src="../../assets/search.png" alt="" class="searchImg" @click="searchData(1)">
                <!--<el-button size="mini" @click = 'getDataList'>搜索</el-button>-->
              </div>
            </div>
            <el-button size="mini" type="primary" plain @click="addRow(1)">添加</el-button>
            <el-button size="mini" type="danger" plain @click="deleteData(1)">删除</el-button>
          </div>

          <div class="album-class">
            <!--曲册展示-->
            <el-table :data="album_table" style="width: 100%;margin:auto"
                      ref="albumtable"
                      @select="albumRowClick" @select-all="handelSelectAlbumAll"
                      class="drum-table" highlight-current-row>
              <!--多选框-->
              <el-table-column
                type="selection"
                width="50">
              </el-table-column>

              <el-table-column label="名称" width="" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" :disabled="!scope.row.disabled"></el-input>
                </template>
              </el-table-column>

              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.edit" type="success" plain size="mini" class="operate-btn  success-btn"
                             @click="saveRow(scope.row,1)">保存
                  </el-button>
                  <el-button v-if="scope.row.edit" class="cancel-btn operate-btn theme-btn" size="mini"
                             type="warning" plain @click="cancelEdit(1)">取消
                  </el-button>
                  <el-button v-else type="primary" plain size="mini" class="operate-btn"
                             @click="editRow(scope.row,1)">编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!--章节-->
        <div class="allocate">
          <span class="title">章节</span>
          <div class="middle-operate">
            <div class="search-container1">
              <div>

                <input v-model="searchChapter" type="search" placeholder="请输入章节名称" class="search-input">
                <img src="../../assets/search.png" alt="" class="searchImg" @click="searchData(2)">
              </div>
            </div>
            <el-button size="mini" type="primary" plain @click="addRow(2)">添加</el-button>
            <el-button size="mini" type="danger" plain @click="deleteData(2)">删除</el-button>
          </div>
          <div class="chapter-class">
            <!--章节展示-->
            <el-table :data="chapter_table" style="width: 100%;margin:auto" @selection-change="chapter_selectionChange"
                      class="drum-table" highlight-current-row>
              <!--多选框-->
              <el-table-column
                type="selection"
                width="50"
              >

              </el-table-column>

              <el-table-column label="名称" width="" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" :disabled="!scope.row.disabled"></el-input>
                </template>
              </el-table-column>

              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.edit" type="success" plain size="mini" class="operate-btn  success-btn"
                             @click="saveRow(scope.row,2)">保存
                  </el-button>
                  <el-button v-if="scope.row.edit" class="cancel-btn operate-btn theme-btn" size="mini"
                             type="warning" plain @click="cancelEdit(2)">取消
                  </el-button>
                  <el-button v-else type="primary" plain size="mini" class="operate-btn"
                             @click="editRow(scope.row,2)">编辑
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

      </el-container>
    </el-main>
</template>

<script>
  export default {
    name: "categoryManage",
    props: [],
    data() {
      return {
        // checked: true,
        //乐器表格数据
        drum_table: [],
        //曲册表格数据
        album_table: [],
        //章节表格数据
        chapter_table: [],

        // 新增行标记   区分是新增还是修改
        addNewRowFlag: false,

        chapterData: [],
        albumData: [],

        // 搜索条件
        search: "",

        // 乐器选择结果
        checkDrum: [],
        // 曲册选择结果
        checkAlbum: [],
        // 章节选择结果
        checkChapter: [],


        //用作全选的第二内容
        chaptersAll: [],


        // 当前编辑的内容，用作取消编辑时恢复数据
        currentEdit: '',

        // 当前新增的id, 会作为下一级的pid, 提交保存，
        // currentReturnId:0,

        //  当前乐器id
        currentDrumId: '',
        //  当前曲册id
        currentAlbumId: '',


        //  搜索字段
        searchDrum: '',
        searchAlbum: '',
        searchChapter: '',

      }
    },
    created() {
      //  获取类目信息（默认是乐器）
      this.getData(0, 0)
    },
    methods: {

      // 获取类目列表
      getData(id, flag) {

        let params = {
          pid: id ? id : 0,
          keywords: '',
        };
        if (flag === 0) {
          //  乐器
          params.keywords = this.searchDrum
        } else if (flag === 1) {
          //  曲册
          params.keywords = this.searchAlbum
        } else {
          //  章节
          params.keywords = this.searchChapter
        }


        // console.log("请求类目参数");
        // console.log(params);
        this.$api.get('/category/list.json', params)
          .then(res => {
            // 为数据添加编辑状态
            this.addEdit(res.data, flag);
          }, error => {
            this.$message.error(error.msg);
          })
          .catch(err => {
            console.log(err);
            this.$message.error("数据请求异常！");
          })
      },

      /**
       * 条件搜索
       * 1 区分类目
       * 2 每次点击搜索 清空下一级列表数据
       * 3  下一级不能添加行 清空当前选中状态  章节没有下一级 不用清空
       * */
      // 条件搜索类目
      searchData(flag) {
        if (flag === 0) {
          // 清空列表
          this.album_table = [];
          this.chapter_table = [];
          // 清空当前选中的乐器
          this.currentDrumId='';
          // 获取乐器类目
          this.getData(0, 0);
        } else if (flag === 1) {
          // 清空章节列表
          this.chapter_table = [];
          // 清空当前的曲册
          this.currentAlbumId='';
          // 获取乐器的曲册类目
          this.getData(this.currentDrumId, 1);
        } else {
          //  获取曲册的章节类目
          this.getData(this.currentAlbumId, 2);
        }

      },

      // 增加行
      addRow(flag) {
        let table_data = '';
        if (flag === 0) {
          //乐器
          // 清除所有选中的项  再新增
          table_data = this.drum_table
        } else if (flag === 1) {
          //曲册
          if (this.currentDrumId === '') {
            return this.$message.error("请先选择乐器！");
          }
          table_data = this.album_table
        } else {
          //章节
          if (this.currentAlbumId === '') {
            return this.$message.error("请先选择曲册！");
          }
          table_data = this.chapter_table
        }

        //  判断当前编辑的行是否被保存
        for (let i of table_data) {
          if (i.edit) {
            return this.$message({
              message: '请先保存数据!',
              type: 'warning'
            });
          }
        }

        let newLine = {
          name: this.name,
          edit: true, // 新增时处于可编辑状态，所以按钮是保存和取消
          disabled: true,// 打开编辑状态
          // id:-1  // 可以防止在未保存
        };
        // 添加到第一行
        if (flag === 0) {
          //乐器
          this.drum_table.unshift(newLine);
        } else if (flag === 1) {
          //曲册
          this.album_table.unshift(newLine);
        } else {
          //章节
          this.chapter_table.unshift(newLine);
        }

        // 修改添加行标记
        this.addNewRowFlag = true;

      },

      // 保存行
      saveRow(row, flag) {
        // flag 标记保存成功后获取响应的数据
        // 空不能保存
        if (!row.name) {
          return this.$message({
            message: '数据不能为空!',
            type: 'warning'
          });
        }
        // 隐藏 保存 取消按钮
        row.edit = false;
        // 不可编辑
        row.disabled = false;

        // 判断是修改还是新增
        if (this.addNewRowFlag === true) {
          // 保存成功 改变addNewRowFlag标识 并获取数据重新渲染列表
          this.saveData(row.name, flag);
        } else {
          this.addNewRowFlag = true;
          this.modifyData(row.name);
        }
      },

      //编辑行
      editRow(row, flag) {
        let table_data = '';
        if (flag === 0) {
          //乐器
          console.log("编辑乐器");
          table_data = this.drum_table
        } else if (flag === 1) {
          //曲册
          console.log("编辑曲册");
          table_data = this.album_table
        } else {
          //章节
          console.log("编辑章节");
          table_data = this.chapter_table;
          console.log(table_data);
        }

        //  判断当前编辑的行是否被保存  table_data没有的时候回报错  要不要try  catch ?
        for (let i of table_data) {
          if (i.edit) {
            return this.$message({
              message: '请先保存数据!',
              type: 'warning'
            });
          }
        }
        // 保存当前编辑的内容
        this.currentEdit = row;

        //保存取消按钮 状态更换变量通过edit来定义实现
        row.edit = !row.edit;
        row.disabled = true;

      },

      // 取消编辑
      cancelEdit(flag) {
        // 重新获取数据
        if (flag === 0) {
          //  乐器
          this.getData(0, 0)
        } else if (flag === 1) {
          // 曲册
          this.getData(this.currentDrumId, 1)
        } else {
          this.getData(this.currentAlbumId, 2)
        }

      },


      // 乐器全选  取消当前选中
      handelSelectAll() {
        // 取消显示的曲册和章节数据
        this.album_table = [];
        this.chapter_table = [];
        this.$refs.drumtable.clearSelection();
      },

      //乐器单选
      drumRowClick(selection, row) {
        //将显示的曲册和章节删掉
        this.album_table = [];
        this.chapter_table = [];
        if (row.id) {
          // 有id  说明不是新增的乐器被选中
          this.currentDrumId = '';  // 取消选中也会触发  所以先置空  选中的集合里有值  说明当前点击的是选中的  再添加
          if (selection.length > 0) {
            this.currentDrumId = row.id;
            // 获取新的曲册和章节信息
            this.getData(row.id, 1);
          }
        }
        // 将其他项变为选不中 这时候只有两项   第一项变为选不中就可以了
        if (selection.length > 1) {
          this.$refs.drumtable.toggleRowSelection(selection[0], false);
        }
      },

      // 曲册全选 取消当前选中
      handelSelectAlbumAll() {
        // 取消显示的章节数据
        this.chapter_table = [];
        // 清除当前选中的乐器id
        this.currentAlbumId = '';
        this.$refs.albumtable.clearSelection();
      },

      // 曲册单选
      albumRowClick(selection, row, index) {
        // 清空章节列表
        this.chapter_table = [];
        //记录当前选中的乐器id currentAlbumId


        if (row.id) {
          // 有id  说明不是新增被选中  可以去获取章节类目
          this.currentAlbumId = '';
          if (selection.length > 0) {
            // alert(row.id);
            this.currentAlbumId = row.id;
            // 获取新的章节信息
            this.getData(row.id, 2);
          }
        }


        //
        // if(selection.length>0){
        //   // alert(row.id);
        //   this.currentAlbumId = row.id;
        //   // 获取新的曲册和章节信息
        //   this.getData(row.id, 1);
        // }
        // // 其他选中变为不选
        if (selection.length > 1) {
          this.$refs.albumtable.toggleRowSelection(selection[0], false);
        }
      },


      // 选中章节时触发
      chapter_selectionChange(val) {
        // console.log(val);
        this.checkChapter = val;
      },

      //新增保存数据
      saveData(name, flag) {
        let param;
        if (flag === 0) {
          param = {
            "name": name,
            "pid": 0   // 当前乐器的id  添加乐器 默认是0
          };
        } else if (flag === 1) {
          // console.log(this.currentDrumId);
          param = {
            "name": name,
            "pid": this.currentDrumId  // 当前选中的乐器id
          };
        } else {
          param = {
            "name": name,
            "pid": this.currentAlbumId   // 当前选中的曲册id
          };
        }

        // console.log(param);

        let res = this.$api.post('/category/add.json', param);
        res.then(res => {
          this.$message({
            message: '保存成功!',
            type: 'success'
          });
          // 改变状态
          this.addNewRowFlag = false;
          // 重新获取数据 根据保存数据的不同 获取不同的列表数据  类似刷新操作
          if (flag === 0) {
            //  获取乐器  不用传id
            this.getData(0, 0)
          } else if (flag === 1) {
            // 获取曲册  此时currentAddId  应该是乐器id 获取它的曲册列表
            this.getData(this.currentDrumId, 1)
          } else {
            // 章节   此时currentAddId  应该是曲册id  获取它的章节列表
            this.getData(this.currentAlbumId, 2)
          }

        }, error => {
          this.$message.error("保存失败：" + error.msg);
        })
          .catch(err => {
            console.log(err);
            this.$message.error("保存异常！");
          })
      },

      // 修改数据
      modifyData(name) {
        let param = {
          "name": name,
          "id": this.currentEdit.id  // 当前修改的id
        };

        let res = this.$api.put('/category/modify.json', param);
        res.then(res => {
          if (res.code === 200) {
            this.$message({
              message: '修改成功!',
              type: 'success'
            });
            // 改变编辑状态
            this.addNewRowFlag = false;
          }
        }, err => {
          this.$message.error(err.msg)
        })
          .catch(err => {
            console.log(err);
            this.$message({
              message: '修改异常!',
              type: 'warning'
            });
          })
      },

      // 删除数据  删除后重新获取数据
      deleteData(flag) {
        let deleteFlag = false;
        if (flag === 0) {
          // 乐器
          if (this.currentDrumId === '') {
            return this.$message.error("请选择删除项!");
          }
          let res = this.$api.delete('/category/delete.json', {id: this.currentDrumId});
          res.then(res => {
            if (res.code === 200) {
              deleteFlag = true;
              this.$message({
                message: '删除成功!',
                type: 'success'
              });
              //清空当前选中的id
              this.currentDrumId = '';
              //  获取新数据
              this.getData(0, 0)
            }
          }, err => {
            deleteFlag = false;
            this.$message.error(err.msg)
          })
            .catch(err => {
              deleteFlag = false;
              this.$message.error("删除异常！")
            })

        } else if (flag === 1) {
          // 曲册
          if (this.currentAlbumId === '') {
            return this.$message.error("请选择删除项!");
          }

          this.$api.delete('/category/delete.json', {id: this.currentAlbumId})
            .then(res => {
              deleteFlag = true;
              this.$message({
                message: '删除成功!',
                type: 'success'
              });
              // 清空当前曲册id
              this.currentAlbumId = '';
              //  获取新数据
              this.getData(this.currentDrumId, 1)
            }, err => {
              deleteFlag = false;
              this.$message.error(err.msg)
            })
            .catch(err => {
              deleteFlag = false;
              this.$message.error("删除异常！")
            })
        } else {
          //章节
          if (this.checkChapter.length === 0) {
            return this.$message.error("请选择删除项!");
          }
          this.checkChapter.forEach(item => {
            console.log("删除乐器数据:" + item.id);
            this.$api.delete('/category/delete.json', {id: item.id})
              .then(res => {

                deleteFlag = true;
                this.$message({
                  message: '删除成功!',
                  type: 'success'
                });
                //  获取新数据
                this.getData(this.currentAlbumId, 2)
              }, err => {
                deleteFlag = false;
                this.$message.error(err.msg)
              })
              .catch(err => {
                deleteFlag = false;
                this.$message.error("删除异常！")
              })
          });
        }


      },

      // 添加编辑状态
      addEdit(data, flag) {
        data.forEach(item => {
          item.edit = false;
        });
        // console.log(data); // 数据正确
        console.log(flag);
        if (flag === 0) {
          // 乐器
          this.drum_table = data.reverse();
          // console.log(this.drum_table);
        } else if (flag === 1) {
          // 曲册
          this.album_table = data;
        } else {
          //章节
          this.chapter_table = data;
        }
      },



    }
  }
</script>

<style scoped>

  .main-item-container {
    display: flex;
    justify-content: center;
    /*border: cornflowerblue 1px solid;*/
  }

  .allocate {
    flex: 1;
    /*width: 400px;*/
    /*height: 500px;*/
    border: #dbdbdb 1px solid;
    background-color: #fff;
    /*margin-bottom: 10px;*/
  }

  .title {
    display: inline-block;
    width: 100%;
    height: 36px;
    border-bottom: #dbdbdb 1px solid;
    line-height: 36px;
    text-align: center;
    justify-content: center;
    align-items: center;
    background-color: #fff;
  }

  /*整体布局结束*/

  /*中间操作布局*/
  .middle-operate {
    width: 100%;
    height: 50px;
    border-bottom: #dbdbdb 1px solid;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /*<!--搜索框布局-->*/
  .search-container1 {
    width: 200px;
    margin-right: 10px;
    /*padding-right: 20px;*/
    /*display: flex;*/
    /*justify-content: space-between;*/

  }

  .search-container1 > div {
    width: 200px;
    height: 30px;
    display: flex;
    align-items: center;
    border: #dbdbdb 1px solid;
    border-radius: 30px;
    padding-left: 20px;
    background-color: #fff;
  }

  /*搜索小图标*/
  .searchImg {
    /*display: inline-block;*/
    width: 15px;
    height: 15px;
    /*padding-top: 5px;*/
    /*padding-bottom: 5px;*/
    /*padding-right: 12px;*/
    /*!*background-color: #E9EEF3;*!*/
    /*margin-right: 10px;*/
    /*border-radius: 0 30px 30px 0;*/
  }

  .search-input {
    width: 150px;
    border: 0;
    height: 25px;
    font-size: 12px;
    /*取消点击时出现的边框*/
    outline: none;
  }

  /* 搜索结束*/

  /*内容展示布局*/
  .drum-table, .album-table, .chapter-table {
    margin-left: 14px;
  }

  .operate-btn {
    width: 40px;
    height: 22px;
    font-size: 10px;
    text-align: center;
    padding: 0;
  }

  /*表格布局*/
  .el-table td, .el-table th {
    padding: 0 !important;
  }

  /* 样式穿透*/
  .el-input >>> input.el-input__inner {
    height: 28px !important;
    margin-bottom: 5px;
    margin-top: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/categoryManage/CategoryManage.vue